export function getCircumference(radius: number): number {
	return 2 * Math.PI * radius;
}

export function getAdjustedCircumferencePercentage(
	circumference: number,
	progress: number,
	showRemaining: boolean,
): number {
	return showRemaining ? (circumference * progress) / 100 : (circumference * (100 - progress)) / 100;
}
